import { createFileRoute, Outlet } from '@tanstack/react-router';

import { getKeycloak } from '@/auth/keycloak-instance';

export const Route = createFileRoute('/_auth')({
  beforeLoad: () => {
    const keycloak = getKeycloak();
    if (!keycloak.authenticated) {
      void keycloak.login({ redirectUri: window.location.href });
      // Suspend rendering while Keycloak performs the full-page redirect.
      return new Promise<never>(() => undefined);
    }
  },
  component: () => <Outlet />,
});
